import { createWebHistory, createRouter } from 'vue-router'

const routes = [
    { path: '/', name: 'index', component: () => import('@/views/IndexView.vue') },
    { path: '/blog', name: 'blog', component: () => import('@/views/blog/BlogListView.vue') },
    { path: '/blog/search', name: 'blog-search', component: () => import('@/views/blog/BlogListView.vue') },
    { path: '/blog/tag/:tag', name: 'blog-tag', component: () => import('@/views/blog/BlogListView.vue') },
    { path: '/blog/category/:category', name: 'blog-category', component: () => import('@/views/blog/BlogListView.vue') },
    { path: '/blog/:slug', name: 'post', component: () => import('@/views/blog/PostView.vue') },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/views/NotFoundView.vue') }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        if (to.hash) {
            // the sticky nav is about 56px tall; give a freshly loaded view a moment to render
            return new Promise((resolve) => {
                setTimeout(() => resolve({ el: to.hash, top: 72, behavior: 'smooth' }), to.name !== from.name ? 300 : 0);
            });
        }
        // Home from one of its own sections (/#aboutme -> /) glides back up to the hero.
        if (to.name === 'index' && from.name === 'index') return { top: 0, behavior: 'smooth' };
        if (to.name === from.name && to.name !== 'post') return false; // paging/filtering keeps position
        return { top: 0 };
    }
});

export default router
